export const paths = {
  kioskWelcome: "/kiosk",
  kioskSessions: "/kiosk/sessions",
  kioskSession: "/kiosk/sessions/:sessionId",
  kioskLocation: "/kiosk/location",
  kioskLogin: "/kiosk/login",
  challenge: "/challenge",
  feedbackWelcome: "/feedback/:id",
  feedbackForm: "/feedback/:id/form",
  kioskFeedback: "/kiosk/feedback/:id",
  thankYou: "/thank-you",
  thankYouKiosk: "/thank-you?return=kiosk",
  login: "/login",
  admin: "/admin",
  syncStatus: "/admin/sync-status",
  serviceTypes: "/admin/service-types",
  programQuestions: "/admin/program-questions",
  programConfig: "/admin/program-config",
  rollout: "/admin/rollout",
  kioskDevices: "/admin/kiosk-devices",
  formBuilder: "/admin/forms",
  formBuilderForm: "/admin/forms/:formId",
  modules: "/admin/modules",
  newModule: "/admin/modules/new",
  module: "/admin/modules/:id",
  sessionTemplates: "/admin/session-templates",
  newSessionTemplate: "/admin/session-templates/new",
  sessionTemplate: "/admin/session-templates/:id",
  diagnostics: "/diagnostics",
} as const

export const pathHelpers = {
  toFeedbackWelcome: (id: string) => `/feedback/${id}`,
  toFeedbackForm: (id: string) => `/feedback/${id}/form`,
  toKioskFeedback: (id: string) => `/kiosk/feedback/${id}`,
  toKioskSession: (sessionId: string) => `/kiosk/sessions/${sessionId}`,
  toFormBuilderForm: (formId: string) => `/admin/forms/${formId}`,
  toModule: (id: string) => `/admin/modules/${id}`,
  toSessionTemplate: (id: string) => `/admin/session-templates/${id}`,
  toThankYouPath: (kiosk: boolean) =>
    kiosk ? "/thank-you?return=kiosk" : "/thank-you",
} as const
